import navigation from './components/navigation'
import skipLinks from './components/skip-links';
import tables from './components/tables';
import dialogs from './components/dialogs';
import tabs from './components/tablist';
import footer from './components/footer';
import external from "./components/external";
import accordions from "./components/accordions";
import tooltips from "./components/tooltips";
import acfMaps from "./components/acf-maps";
import eventHeader from "./components/event-header";
import loadMoreNews from "./components/load-more-news";
import showPassword from "./components/show-password";
import countdown from "./components/countdown";
import './components/brochure-optin';
import registrationDetails from "./components/registration-details";
import videoAutoplay from "./components/video-autoplay";

showPassword();
eventHeader();
tooltips();
accordions();
external();
footer();
acfMaps();
tabs( document.querySelectorAll( '.tabs' ) );
skipLinks( document.getElementById( 'skip-to-content' ) );
navigation( document.querySelector( '.header__nav' ) )
tables( document.querySelectorAll( 'table' ) );
dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );
loadMoreNews();
countdown( document.querySelectorAll( '[data-countdown]' ) );
registrationDetails();
videoAutoplay();
